<template>
  <CurationRenderer
    class="jps-project"
    v-if="orgPage"
    :curation="orgPage"
    :show-edit="showEdit"
    @edit="edit()"
  />
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
  disableDefaultMargin: {
    top: true,
  }
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { langPath } = useI18n()
const route = useRoute()
const router = useRouter()
const dataStore = useDataStore()
const userStore = useUserStore()

const orgPage = computed(() => {
  return dataStore.curation(route.params.orgId + '-org')
})

const showEdit = computed(() => {
  return orgPage.value && userStore.hasEditForData(orgPage.value)
})

const edit = () => {
  router.push(langPath(`/management/${route.params.orgId}/page`))
}
</script>

<style lang="scss" scoped></style>
